
import
  {
    WDApi,
    WDFormat,
    WDFormOptionselect,
    WDButton,
  } from 'wd';

import LookupCard from './lookup-card';

export default class TransactionsCard extends LookupCard
{
  #glAccountSelector;
  #suspendEvents = false;
  #glAccount;

  constructor()
  {
    super({ title: 'GL Transactions' })
    this.classList.add('transactions-card');

    this.dataset.mode = 'all-gls';
  };

  connectedCallback()
  {
    super.connectedCallback();
    this.addGLAccountSelector();

    this.list.on('results:fetched',(evt) => this.updateListFooter(evt.detail) );

    this.list.once('results:fetched',() => {
      const ss = this.querySelector('input[name="search_string"]');
      const btn = new WDButton({ fasIcon: 'circle-info' });
      ss.parentElement.append(btn);

      const helpContainer = wdc(`<div class="search-help">
        
        <p><b>Use this field to search by remarks, amounts, or dates.</b></p>
        <div>Examples:</div>
        <ul>
          <li>Search remarks: <br>
            <b>"Verizon"</b>
          </li>
          <li>
            Search remarks with an amount:<br>
            <b>"Verizon, 100"</b>
          </li>
          <li>
            Search remarks on a date:<br>
            <b>"Verizon, 01/01/2025"</b>
          </li>
          <li>Search for remarks between dates: <br>
          <b>"Verizon, >=01/01/2025, <=12/31/2025"</b>
          </li>
          <li>Search for remarks between dates and amounts:<br>
          <b>"Verizon, >=01/01/2025, <=12/31/2025, >=100, <=200"</b>
          </li>
        </ul>
      </div>`)

      btn.dropdown.append(helpContainer);
    });
   
  }

  updateListFooter(results)
  {
    const count = results.length;
    const limit = this.list.fetch.limit;
    
    let resultStr;
    
    if (count === 0) {
      resultStr = 'No transactions found';
    } else if (count >= limit) {
      resultStr = `${count}+ transactions found (limit: ${limit})`;
    } else {
      resultStr = `${count} transactions found`;
    }

    this.list.footer.replaceChildren(resultStr);
  }


  get glAccount()
  {
    return this.#glAccountSelector?.value;
  }

  set glAccount(val)
  {
    this.filters.value = [];
    delete this.list.fetch.filters;

    //default to gl ascending sort 
    this.list.fetch.sort_field = 'gl_account_label';
    this.list.fetch.sort_dir = 'asc';

    this.#glAccountSelector.value = val;
    //this.list.req();

    this.once('card:shown',() => {
      setTimeout( () => {
        localStorage.selectedCard = 'wd-card-glaccounts';
      },100);   
    });
   
  }

  set searchString(val)
  {
    this.#glAccountSelector.value = null;
    this.handleGLChange(true);
    
    this.filters.getFilterWithName('search_string').value = val;

    //default to gl ascending sort 
    this.list.fetch.sort_field = 'gl_account_label';
    this.list.fetch.sort_dir = 'asc';

    this.once('card:shown', () =>
    {
      setTimeout(() =>
      {
        localStorage.selectedCard = 'wd-card-vendors';
      }, 100);
    });

    this.filters.trigger('filter:apply');
  };

  formatAmount(str,data)
  {
    const amount = data.debit_credit == 'D' ? 0 - data.amount : data.amount;

    const wrapper = wdc('<div class="amount-wrapper"/>');
    wrapper.append(wdc(`<div class="debit-credit">${data.debit_credit}</div>`));
    wrapper.append(wdc(`<div class="amount-value">${WDFormat.currencyDecimals(data.amount)}</div>`));

    return wrapper;
  }

  get fetchURI()
  {
    return `/lookup/companies/${this.company.value}/transactions`;
  }

  get fetchApi()
  {
    return new WDApi(this.fetchURI, {
      limit: 500,
      sort_field: 'gl_account_label',
      sort_dir: 'asc',
    });
  }

  get listConfig()
  {
    return {
      columns: [
        { label: 'GL Account', value: 'gl_account_label', sort:true },
        { label: 'Date', value:'trans_date', format:WDFormat.date, sort:true},
        { label: 'Amount', value: 'amount', format: WDFormat.currencyDecimals, sort:true},
        { label: 'D/C', value:'debit_credit'},
        { label: 'Code', value:'trans_code'},
        { label: 'Remarks', value:'postingremark'},
      ],
      //fetch: this.fetchApi,
      valueField: 'id',
      focusable: true,
      method: 'post',
      options: [],
      click: (item, row) => {},    //ensures the list responds to clicks
      content: (item, data) => {
        this.list.addListItem(item, data);
        this.addJobCosts(item, data);
      },
      filters: [
        { 
          type: 'text', 
          name: 'search_string', 
          placeholder: 'Search Transactions', 
          static: true,
        },
      ]
    };

  };

  /**
   * adds a sub-row under a transaction with the job and cost code it was posted to.
   * rows with no job costing (most companies) get nothing, so they look as they always have.
   * a line split across several cost codes lists each one with its amount, under its job
   */
  addJobCosts(item, data)
  {
    const jobCosts = data.job_costs || [];

    if (jobCosts.length === 0) return;

    const jobs = new Map();

    jobCosts.forEach(jc => {
      if (!jobs.has(jc.job_label)) jobs.set(jc.job_label, []);
      jobs.get(jc.job_label).push(jc);
    });

    const subRow = wdc('<div class="job-costs"/>');

    jobs.forEach((costCodes, jobLabel) => {
      const entry = wdc('<div class="job-cost"/>');

      entry.append(this.jobCostLabel(jobLabel));

      costCodes.forEach(jc => {
        entry.append(wdc('<span class="separator">&middot;</span>'));
        entry.append(this.jobCostLabel(jc.cost_code_label));

        if (jobCosts.length > 1)
        {
          entry.append(wdc(`<span class="job-cost-amount">${WDFormat.currencyDecimals(jc.amount)}</span>`));
        }
      });

      subRow.append(entry);
    });

    item.append(subRow);
  }

  /**
   * labels come from the api as "code name" - the code is bolded so it can be picked out
   */
  jobCostLabel(label)
  {
    const [code, ...name] = String(label).split(' ');

    const elem = wdc('<span class="job-cost-label"/>');
    elem.append(wdc('<b/>'));
    elem.firstChild.textContent = code;

    if (name.length > 0) elem.append(' ' + name.join(' '));

    return elem;
  }

  handleSelected(evt)
  {
    //this.triggerHammer(evt,evt.detail.model.gl_account_number_formatted);
  };

  addGLAccountSelector()
  {
    //gl accounts are keyed by account number now that this reads live tai, not by
    //the id compass used to hand out, so this deliberately ignores anything left
    //in the old glAccount key
    const curVal = localStorage?.glAccountLive !== undefined ? JSON.parse(localStorage.glAccountLive) : null;

    this.#glAccountSelector = new WDFormOptionselect({
      name: 'gl_account_id',
      placeholder: 'Select GL Account',
      value: curVal
    });

    this.#glAccountSelector.suffix.append(wdc('<span class="fa-solid fa-times"></span>'));
    this.#glAccountSelector.suffix.addEventListener('click', evt => {
      evt.cancelBubble = true;
      evt.stopPropagation = true;
      evt.preventDefault();
      this.#glAccountSelector.value = null;
    });

    this.cardList.on('company:selected',() => {
      this.#glAccountSelector.value = null;

      if (this.cardList.company)
      {
        this.#glAccountSelector.fetch = new WDApi(`/lookup/companies/${this?.cardList?.company.value}/glaccounts`,{show_defaults:'0'});
      }
      else
      {
        this.#glAccountSelector.fetch = null;
      }
      
    });
   
    this.#glAccountSelector.on('change',() => this.handleGLChange() );

    this.navbar.right.addItem(this.#glAccountSelector);
    this.navbar.right.querySelector('input').classList.add('form-control-sm');
    
  };

  handleGLChange(noReq)
  {
    if (!this.cardList.company || this.#suspendEvents == true) return;

    const val = this.#glAccountSelector.value;

    if (val === null)
    {
      this.#glAccountSelector.classList.remove('has-value');
      delete localStorage.glAccountLive;
      this.dataset.mode = 'all-gls';
      delete this.list.fetch.gl_account_id;
    }
    else
    {
      this.#glAccountSelector.classList.add('has-value');
      localStorage.glAccountLive = JSON.stringify(val);
      this.dataset.mode = 'single-gl';
      this.list.fetch.gl_account_id = val.value;
    }

    console.log('Handle GL Change',this.list.fetch?.gl_account_id);

    if (!noReq) this.list.req();
  }

};

customElements.define('transactions-card', TransactionsCard);

